import React from 'react';
import SwotAnalysis from '../components/SwotAnalysis';
import Pageheader from '../utils/headerHelment';

const SwotAnalysisView = props => {
    return (
        <>
            <Pageheader title="LENS - SWOT Analysis" />
            <SwotAnalysis />
        </>
    );
};

export default SwotAnalysisView;
